import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import '../theme/index.css';
import "./assets/css/index.css";
import _tools from "./framework/common/qds_tools";

Vue.config.productionTip = false;
Vue.use(ElementUI);
if (process.env.NODE_ENV !== 'development') {
  router.beforeEach(async (to, from, next) => { // 权限验证
    if (_tools.getCookie('QDS_COOKIE') || _tools.getCookie('QDS_LOGIN_INFO')) {
      if (to.query.source) {
        sessionStorage.setItem('source', to.query.source);
        setTimeout(() => {
          next()
        }, 500)
      } else {
        next()
      }
    } else {
      return (window.location.href = `https://account.quandashi.com/?callback=https://${encodeURIComponent(window.location.host)}`)
    }
  })
}
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js